import { render, staticRenderFns } from "./membercardLead.vue?vue&type=template&id=199a5dd6&scoped=true"
import script from "./membercardLead.vue?vue&type=script&lang=js"
export * from "./membercardLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199a5dd6",
  null
  
)

export default component.exports